import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OPTION_LABELS_FEATURE_KEY, optionLabelsAdapter, OptionLabelsState } from './option-labels.reducer';

// Lookup the 'OptionLabels' feature state managed by NgRx
export const getOptionLabelsState = createFeatureSelector<OptionLabelsState>(OPTION_LABELS_FEATURE_KEY);

const { selectAll, selectEntities } = optionLabelsAdapter.getSelectors();

export const getOptionLabelsLoaded = createSelector(getOptionLabelsState, (state: OptionLabelsState) => state.loaded);

export const getOptionLabelsError = createSelector(getOptionLabelsState, (state: OptionLabelsState) => state.error);

export const getAllOptionLabels = createSelector(getOptionLabelsState, (state: OptionLabelsState) => selectAll(state));

export const getOptionLabelsEntities = createSelector(getOptionLabelsState, (state: OptionLabelsState) =>
  selectEntities(state)
);
